import React from "react";
import { Container, ButtonContainer } from "./styled";
import MenuButton from "./MenuButton";
import { Hr } from "../../styled";
import BoardIcon from "@mui/icons-material/Dashboard";
import BackgroundIcon from "@mui/icons-material/Wallpaper";
import ActivitySection from "./ActivitySection/ActivitySection";
const MainMenu = (props) => {
  return (
    <Container>
      <ButtonContainer>
        <MenuButton
          icon={<BoardIcon fontSize="small" color="inherit" />}
          title="Về bảng này"
          description="Thêm mô tả cho bảng"
          clickCallback={() => props.menuCallback("Về bảng này")}
        />
        <MenuButton
          icon={<BackgroundIcon fontSize="small" color="inherit" />}
          title="Thay đổi nền"
          description="Thay đổi nền của bảng"
          clickCallback={() => props.menuCallback("Thay đổi nền")}
        />
      </ButtonContainer>
      <Hr />
      <ActivitySection />
    </Container>
  );
};

export default MainMenu;
